import { EXCEPTIONAL_SITENAME } from "@/constants"

export const getPlpParams = (obj, targetKey) => {
  let result = null
  for (const key in obj) {
    if (Object.hasOwn(obj, key)) {
      if (key === targetKey) {
        return obj[key]
      }

      if (typeof obj[key] === "object" && obj[key] !== null) {
        result = getPlpParams(obj[key], targetKey)

        if (result !== null) {
          return result
        }
      }
    }
  }
  return result
}

export const addCollectionParam = (url = "", brandName = "") => {
  let endPoint = url
  // if (brandName?.toLowerCase() !== EXCEPTIONAL_SITENAME)
  endPoint = `${url}&collections=${brandName?.toLowerCase()}`
  return endPoint
}

export function reformatSortString(sortString, persona) {
  if (!sortString) return null
  return getFacetFieldWithLabel(sortString, persona)
}

export const getFacetFieldWithLabel = (params, persona = "GST") => {
  switch (params) {
    case "Price_Range":
      return `priceList.${persona}.finalPrice_d`

    case "price desc":
      return `priceList.${persona}.finalPrice_d desc`

    case "price asc":
      return `priceList.${persona}.finalPrice_d asc`

    case "featured":
      return ""

    default:
      return null
  }
}

export const reformatFacetString = (facetString, facetLabels, persona) => {
  if (!facetString) return []

  // Remove the prefix "facet:'" and the trailing "'"
  const cleaned = facetString.replace(FACET_FORMAT_REGEX, "")

  // Split into key-value pairs
  const pairs = cleaned?.split(",")

  // Transform each pair
  const formatted = pairs.map(pair => {
    const [key, value] = pair.split(":")
    if (!key || !value) return ""
    // Find the facet field using facet_labels
    let tagKey = getFacetFieldByLabel(key, facetLabels) || key

    // If Price_Range, get label from facetFieldWithLabel
    if (tagKey === "Price_Range" || key === "Price_Range") {
      tagKey = getPriceFieldFromFacet(facetLabels, persona) || tagKey
      // No quotes for Price_Range values
      // Split by unescaped pipe and join with OR
      const values = value
        ?.split(PIPE_NOT_PRECEDED_BY_BACKSLASH_REGEX)
        .map(v => v.trim().replace(/"/g, '\\"'))
        .join(" OR ")
        .replaceAll(String.raw`\|`, "|")
      return encodeURIComponent(`{!tag="${tagKey}"}${tagKey}:(${values})`)
    } else {
      // Quotes for all other keys
      // Split by unescaped pipe and join with OR
      const values = value
        ?.split(PIPE_NOT_PRECEDED_BY_BACKSLASH_REGEX)
        .map(v => `"${v.trim().replace(/"/g, '\\"')}"`)
        .join(" OR ")
        .replaceAll(String.raw`\|`, "|")

      return encodeURIComponent(`{!tag="${tagKey}"}${tagKey}:(${values})`)
    }
  })

  return formatted
}

export const formatListingData = async (data, stripResponse) => {
  return new Promise((resolve, reject) => {
    try {
      const persona =
        typeof getUserPersona === "function" ? getUserPersona() : "GST"
      const payload = {
        facets: data?.facet_counts?.facet_fields,
        facetLabels: data.fusion?.facet_labels ?? [],
        grouped:
          data?.fusion?.isCollapsePLP === "true" ||
          data?.fusion?.isCollapsePLP === true,
        fusion: data.fusion,
        PlpSwatches: data?.facet_counts?.Plp_Swatches ?? [],
      }

      // Get dynamic price range field
      const priceRange = getPriceRangeField(data, persona, payload.grouped)

      if (priceRange != null) {
        const gap = priceRange.gap
        // eslint-disable-next-line camelcase
        payload.facets.Price_Range = priceRange.counts.map(item =>
          typeof item === "string"
            ? `[${parseInt(item)} TO ${parseInt(item) + gap}]`
            : item
        )
      }

      // mark multiselect
      payload.facets = formatMultiSelectFacets(data)
      // set color swatches
      payload.colors = data.fusion?.color_swatch_labels ?? {}

      if (data.response) {
        if (stripResponse && data.response.docs.length > 3) {
          payload.data = data.response.docs.slice(0, 3)
        } else {
          payload.data = data.response.docs
        }

        payload.total = data.response.numFound
        payload.start = data.response.start
        if (
          data.fusion?.isCollapsePLP === "true" ||
          data.fusion?.isCollapsePLP === true
        ) {
          payload.grouped = true
        }
      } else {
        payload.data = data.grouped[Object.keys(data.grouped)[0]].groups.map(
          doc => doc.doclist.docs[0]
        )
        payload.total = data.grouped[Object.keys(data.grouped)[0]].groups.length
        payload.start = 0
        payload.grouped = true
      }
      resolve(payload)
    } catch (error) {
      reject(error)
    }
  })
}
const getPriceFieldFromFacet = (facetLabels, persona) => {
  const dynamicPriceField = Object.keys(facetLabels).find(key => {
    const normalizedKey = key.toLowerCase()
    return (
      normalizedKey.includes("price") &&
      normalizedKey.includes(persona.toLowerCase())
    )
  })
  return dynamicPriceField || ""
}

const getPriceRangeField = (data, persona, isGrouped) => {
  const facetRanges = data?.facet_counts?.facet_ranges
  if (!facetRanges) return null

  // Find dynamic price field from facet labels
  const facetLabels = data.fusion?.facet_labels || {}
  const dynamicPriceField = getPriceFieldFromFacet(facetLabels, persona)

  if (dynamicPriceField && facetRanges[dynamicPriceField]) {
    return facetRanges[dynamicPriceField]
  }

  // Fallback to hardcoded field names
  const fallbackField = isGrouped
    ? `discountedPriceStartingAt.${persona}_d`
    : `priceList.${persona}.finalPrice_d`

  return facetRanges[fallbackField] || null
}

const formatMultiSelectFacets = data => {
  const facets = Object.entries(data.facet_counts?.facet_fields ?? {}).map(
    fields => ({ [fields[0]]: fields[1] })
  )
  let facetField = data?.fusion?.["facet.field"]
  if (facetField) {
    if (typeof facetField === "string") facetField = [facetField]
    facetField.forEach(item => {
      facets.forEach((filter, index) => {
        if (filter[item]) {
          const obj = {
            [`**${item}`]: filter[item],
          }
          facets.splice(index, 1, obj)
        }
      })
    })
  }
  const result = Object.assign({}, ...facets)
  return result
}

export const getSwatchCount = (isPlp = false) => {
  // If we're in a server environment, return desktop values
  if (typeof window === "undefined") {
    return isPlp ? 3 : 5
  }

  // Client-side logic
  const width = window.outerWidth
  if (isPlp) {
    if (width >= 1024 && width < 1440) {
      return 3
    }
    if (width >= 1440) {
      return 7
    }
    if (width < 812) {
      return 5
    }
    return 3
  } else {
    if (width < 1330) {
      return 3
    }
    return 5
  }
}

export const getPDPUrlWithConfig = (
  category,
  slug,
  plpServletPath,
  general
) => {
  const pdpUrl = gePDPUrlPageDetails(plpServletPath, general, category, slug)
  return pdpUrl
}

export const getSwatchPreset = width => {
  // Server-side rendering (no window object)
  if (typeof window === "undefined") {
    return "?$PLPSwatch_Desk100$"
  }

  // Client-side rendering with width check
  return width <= 768 ? "?$PLPSwatch_Mobile50$" : "?$PLPSwatch_Desk100$"
}
